import { render, staticRenderFns } from "./ScheduleProgramWeek.vue?vue&type=template&id=5583bcea&scoped=true"
import script from "./ScheduleProgramWeek.vue?vue&type=script&lang=js"
export * from "./ScheduleProgramWeek.vue?vue&type=script&lang=js"
import style0 from "./ScheduleProgramWeek.vue?vue&type=style&index=0&id=5583bcea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5583bcea",
  null
  
)

export default component.exports